import {HttpModelConverter} from '../../../../../core/converter/httpModel.converter';
import {UserAccountSummaryModel} from '../entity/userAccountSummary.model';
import {AccountSummaryConverter} from '../../../../common/api.converter/AccountSummary.converter';
import {LovValueSummaryConverter} from '../../../../../common/lov/lov-value/api/converter/LovValueSummary.converter';
import {Injectable} from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class UserAccountSummaryConverter extends HttpModelConverter<UserAccountSummaryModel> {

    constructor() {
        super();
    }

    protected createInstance(): UserAccountSummaryModel {
        return new UserAccountSummaryModel();
    }

    protected enrichObject(result: UserAccountSummaryModel, src: UserAccountSummaryModel) {
        result.account = new AccountSummaryConverter().convert(src.account);
        result.role = new LovValueSummaryConverter().convert(src.role);
    }

}
